import React, { useState } from "react";
import "./sunglasses.css";

function Sunglasses() {
  const categories = {
    MEN: [
      {
        id: 1,
        image: "/sunglass/Y2821C Matt Demin S10549C.jpg", 
        name: "Smarty Y2821C Matt Demin S10549C", 
        price: 15000,             
        size: "Medium",         
      },
      {
        id: 2,
        image: "/sunglass/Y2819B Satin Black S10546B.jpg",
        name: "Smarty Y2819B Satin Black S10546B",
        price: 15000,
        size: "Medium",
      },
      {
        id: 3,
        image: "/sunglass/Y2817B Demi-Gold S11574B.jpg",
        name: "smarty Y2817B Demi-Gold S11574B",
        price: 15000,
        size: "Medium",
      },
    
      {
        id: 4,
        image: "/sunglass/X2956A Man Black.jpg", 
        name: "smarty X2956A Man Black", 
        price: 15000,         
        size: "Medium",         
      },

      {
        id: 5,
        image: "/sunglass/X2892A Black-Silver S11568A.jpg",
        name: "smarty X2892A Black-Silver S11568A",
        price: 15000,
        size: "Medium",
      },

      {
        id: 6,
        image: "/sunglass/X2889B Matt Black-Silver S11565B.jpg",
        name: "smarty X2889B Matt Black-Silver S11565B",
        price: 15000,
        size: "Medium",
      },
      {
        id: 7,
        image: "/sunglass/X2881A Black S11563A.jpg", 
        name: "smarty X2881A Black S11563A",
        price: 15000,             
        size: "Medium",          
      },
      {
        id: 8,
        image: "/sunglass/X2880C Black S11562C.jpg",
        name: "smarty",
        price: 15000,
        size: "Medium",
      },
      {
        id: 9,
        image: "/sunglass/X2861A Matt Black S14524A.jpg",
        name: "smarty X2861A Matt Black S14524A",
        price: 15000,
        size: "Medium",
      },
      {
        id: 10,
        image: "/sunglass/X2844B Transp. Brown S11557B.jpg",
        name: "smarty X2844B Transp. Brown S11557B",
        price: 15000,
        size: "Medium",
      },
      {
        id: 11,
        image: "/sunglass/X1904B Silver.jpg",
        name: "smarty X1904B Silver",
        price: 15000,
        size: "Medium",
      },
      {
        id: 12,
        image: "/sunglass/T Polarized T1900 E.jpg",
        name: "smarty T Polarized T1900 E",
        price: 15000,
        size: "Medium",
      },
      {
        id: 13,
        image: "/sunglass/T Polarized T1900 E.jpg",
        name: "smarty T Polarized T1900 E",
        price: 15000,
        size: "Medium",
      },

      {
        id: 14,
        image: "/sunglass/865811602.jpg",
        name: "Polarized 865811602",
        price: 15000,
        size: "Medium",
      },
      {
        id: 15,
        image: "/sunglass/865921602.jpg", 
        name: "Polarized 865921602",
        price: 15000,             
        size: "Medium",          
      },
      {
        id: 16,
        image: "/sunglass/865811602.jpg",
        name: "Polarized 865811602",
        price: 15000,
        size: "Medium",
      },

      {
        id: 17,
        image: "/sunglass/865811602.jpg",
        name: "Invu ",
        price: 15000,
        size: "Medium",
      },
      {
        id: 18,
        image: "/sunglass/invu/K2512B Matt Blue-Silver.jpg",
        name: "Invu K2512B Matt Blue-Silver",
        price: 25000,
        size: "Medium",
      },
      {
        id: 19,
        image: "/sunglass/invu/K2420C Milky Orange-Green.jpg",
        name: "Invu K2420C Milky Orange-Green",
        price: 25000,
        size: "Medium",
      },
      {
        id: 20,
        image: "/sunglass/invu/E2404A Black.jpg",
        name: "Invu E2404A Black",
        price: 25000,
        size: "Medium",
      },
     
    ],





    WOMEN: [
      {
        id: 21,
        image: "/sunglass/€ Polarized T1903 A Filter Cat.3.jpg",
        name: "Smarty € Polarized T1903 A Filter Cat.3",
        price: 15000,
      },

      {
        id: 22,
        image: "/sunglass/14523 A Filter Cat.3.jpg",
        name: "14523 A Filter Cat.3",
        price: 15000,
      },

      {
        id: 23,
        image: "/sunglass/MYT 18013 60 D 16-130.jpg",
        name: "Smarty MYT 18013 60 D 16-130",
        price: 15000,
      },

      {
        id: 24,
        image: "/sunglass/Polarized A2401 D Filter Cat.3 CE.jpg",
        name: "smarty Polarized A2401 D Filter Cat.3 CE",
        price: 15000,
      },

      {
        id: 25,
        image: "/sunglass/Polarized Y2728 C Filter Cat.3 CE.jpg",
        name: "smarty Polarized Y2728 C Filter Cat.3 CE",
        price: 15000,

      },

      {
        id: 26,
        image: "/sunglass/Polarized Z1904B Filter Cat.S.jpg",
        name: "smarty Polarized Z1904B Filter Cat.S",
        price: 15000,
      },

      {
        id: 27,
        image: "/sunglass/S10547 B Filter cat.3.jpg",
        name: "smarty S10547 B Filter cat.3",
        price: 15000,
      },

      {
        id: 28,
        image: "/sunglass/S10548 Filter Cate.jpg",
        name: "smarty S10548 Filter Cate",
        price: 15000,
      },

      {
        id: 29,
        image: "/sunglass/S11563 A Filter Cat.3 CE.jpg",
        name: "smarty S11563 A Filter Cat.3 CE",
        price: 15000,     
      },

      {
        id: 30,
        image: "/sunglass/S11568A Filter Cat.3.jpg",
        name: "smarty S11568A Filter Cat.3",
        price: 15000,
      },

      {
        id: 31,
        image: "/sunglass/S11574 B Filter Cat.3 C€.jpg",
        name: "smarty S11574 B Filter Cat.3 C€",
        price: 15000,
      },
      {
        id: 32,
        image: "/sunglass/S14524 C Filter Cat.3.jpg",
        name: "smarty S14524 C Filter Cat.3",
        price: 15000,
      },

      {
        id: 33,
        image: "/sunglass/S14524 C Fiter Cat.3 C €.jpg",
        name: "smarty S14524 C Fiter Cat.3 C €",
        price: 15000,

      },

      {
        id: 34,
        image: "/sunglass/S14529 A Filter Cat.3.jpg",
        name: "smarty S14529 A Filter Cat.3",
        price: 15000,
      },

      {
        id: 36,
        image: "/sunglass/invu/B2915C Demi.jpg",
        name: "Invu B2915C Demi",
        price: 25000,
      },
      {
        id: 37,
        image: "/sunglass/invu/K2406B Fuchsia.jpg",
        name: "Invu K2406B Fuchsia",
        price: 25000,
      },
      {
        id: 38,
        image: "/sunglass/invu/Polarized K2514B Filler Cat.3.jpg",
        name: "Invu Polarized K2514B Filler Cat.3",
        price: 25000,
      },
      {
        id: 39,
        image: "/sunglass/invu/Polarsed K25,40. Filter.jpg",
        name: "Invu Polarsed K25,40. Filter",
        price: 25000,
      },
      {
        id: 40,
        image: "/sunglass/invu/T1900E Gold.jpg",
        name: "Invu T1900E Gold",
        price: 25000,
      },

    ],

    KIDS: [


    ],
    // UNISEX: [
    //   {
    //     id: 61,
    //     image: "/unisex1.jpg",
    //     name: "Unisex Sunglass 1",
    //     price: 5000,
    //     brand: "Brand1",
    //     size: "Medium",
    //   },
    //   {
    //     id: 62,
    //     image: "/unisex2.jpg",
    //     name: "Unisex Sunglass 2",
    //     price: 5300,
    //     brand: "Brand2",
    //     size: "Medium",
    //   },
    //   {
    //     id: 63,
    //     image: "/unisex1.jpg",
    //     name: "Unisex Sunglass 1",
    //     price: 5000,
    //     brand: "Brand1",
    //     size: "Medium",
    //   },
    //   {
    //     id: 64,
    //     image: "/unisex2.jpg",
    //     name: "Unisex Sunglass 2",
    //     price: 5300,
    //     brand: "Brand2",
    //     size: "Medium",
    //   },
    //   {
    //     id: 65,
    //     image: "/unisex1.jpg",
    //     name: "Unisex Sunglass 1",
    //     price: 5000,
    //     brand: "Brand1",
    //     size: "Medium",
    //   },
    //   {
    //     id: 66,
    //     image: "/unisex2.jpg",
    //     name: "Unisex Sunglass 2",
    //     price: 5300,
    //     brand: "Brand2",
    //     size: "Medium",
    //   },
    //   {
    //     id: 67,
    //     image: "/unisex1.jpg",
    //     name: "Unisex Sunglass 1",
    //     price: 5000,
    //     brand: "Brand1",
    //     size: "Medium",
    //   },
    //   {
    //     id: 68,
    //     image: "/unisex2.jpg",
    //     name: "Unisex Sunglass 2",
    //     price: 5300,
    //     brand: "Brand2",
    //     size: "Medium",
    //   },
    //   // Add more unisex sunglasses
    // ],
  };
  // Kids sunglasses description
  const kidsDescription = [
    "100% UV Protection – Our polarized sunglasses offer complete UVA and UVB protection, keeping your child’s eyes safe while they play outdoors.",
    "Comfort & Durability – Designed with lightweight, impact-resistant materials to ensure a snug yet comfortable fit for active kids.",
    "Stylish Designs – Available in a variety of fun colors, trendy styles, and different frame sizes to suit all age groups.",
    "Customizable Prescription Lenses – Need prescription sunglasses for your child? Simply upload your prescription while placing the order, and we will customize the lenses accordingly.",
    "Comprehensive Eye Care for Kids – Beyond sunglasses, our clinic provides specialized pediatric eye care services to ensure your child’s vision is developing properly. Regular eye check-ups help detect and correct vision problems early, preventing long-term issues.",
  ];


  const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")) || []);
  const [currentCategory, setCurrentCategory] = useState("MEN");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 8;


  const handleAddToCart = (product) => {
    const existingProduct = cart.find(item => item.id === product.id);
    if (existingProduct) {
      const updatedCart = cart.map(item =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      );
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const newCart = [...cart, { ...product, quantity: 1 }];
      setCart(newCart);
      localStorage.setItem("cart", JSON.stringify(newCart));
    }
    
    // Show alert when product is added
    alert("Product has been added to the cart!");
  };

  const handleNextPage = () => {
    const maxPage = Math.floor(categories[currentCategory].length / itemsPerPage);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPage));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const currentItems = categories[currentCategory].slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  return (
    <div className="sunglasses-container">
      <h1>Sunglasses</h1>
      <div className="category-buttons">
        {Object.keys(categories).map((category) => (
          <button
            key={category}
            className={`category-button ${currentCategory === category ? "active" : ""}`}
            onClick={() => {
              setCurrentCategory(category);
              setCurrentPage(0);
            }}
          >
            {category}
          </button>
        ))}
      </div>




      {currentCategory === "KIDS" && (
        <div className="kids-description">
          <h2>Why Choose Our Kids’ Sunglasses?</h2>
          <ul>
            {kidsDescription.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}




      <div className="items-container">
        {currentItems.map((item) => (
          <div key={item.id} className="item-card">
            <img src={item.image || ""} alt={item.name} className="item-image" />
            <h2 className="item-name">{item.name}</h2>
            <p className="item-price">Rs. {item.price.toLocaleString()}</p>
            <button className="add-to-cart" onClick={() => handleAddToCart(item)}>
              Add to Cart
            </button>
          </div>
        ))}
      </div>

      <div className="pagination">
        <button className="pagination-button" onClick={handlePrevPage} disabled={currentPage === 0}>
          &lt;
        </button>
        <span>
          Page {currentPage + 1} of {Math.ceil(categories[currentCategory].length / itemsPerPage)}
        </span>
        <button
          className="pagination-button"
          onClick={handleNextPage}
          disabled={currentPage === Math.floor(categories[currentCategory].length / itemsPerPage)}
        >
          &gt;
        </button>
      </div>
    </div>
  );
}

export default Sunglasses;
